import { useState } from "react";

export default function TooltipReflex({ children, message }) {
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen(!open);

  return (
    <div className="relative inline-block">

      <div
        className="cursor-pointer"
        onClick={toggle}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        {children}
      </div>


      {open && (
        <div className="absolute left-1/5 -translate-x-3/3 mt-2 w-max max-w-xs
                        px-3 py-2 rounded-lg text-sm text-white bg-black shadow-lg
                        z-50">
          {message}

          <div className="absolute -top-1 left-[5%] -translate-x-1/3
                          w-2 h-2 bg-black rotate-45"></div>
        </div>
      )}
    </div>
  );
}
